import { render } from "./CurrencySwitcher.vue?vue&type=template&id=6ac35877&scoped=true"
import script from "./CurrencySwitcher.vue?vue&type=script&lang=js"
export * from "./CurrencySwitcher.vue?vue&type=script&lang=js"

import "./CurrencySwitcher.vue?vue&type=style&index=0&id=6ac35877&lang=postcss&scoped=true"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.32_vue@3.5.32_webpack@5.106.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ac35877"]])

export default __exports__